import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faAddressCard, faLanguage, faE, faBus, faPen, faEye, faSync, faTimes, faBuildingCircleCheck, faCalendarWeek } from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';
import { Card, Row, Col, OverlayTrigger, Tooltip, Button, Form } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import ChartsContext from "contexts/ChartsContext";
import VolunteerTable from "./DetailsTable/VolunteerTable";
import ShuttleBusTable from "./DetailsTable/ShuttleBusTable";
import TranslationTable from "./DetailsTable/TranslationTable";
import Do3R5PTable from "./DetailsTable/Do3R5PTable";
import PerfectAttendeesTable from "./DetailsTable/PerfectAttendees"
import TodayRegistration from "./DetailsTable/TodayRegistration";
import CheckinTable from "./DetailsTable/CheckinTable";
import Papa from 'papaparse';
import { useHistory } from 'react-router-dom';


function DataSnapshots({ onRefresh }) {
  const [showVolunteerTable, setShowVolunteerTable] = useState(false);
  const [showShuttleBusTable, setShowShuttleBusTable] = useState(false);
  const [showDo3R5PTable, setShowDo3R5PTable] = useState(false);
  const [showTranslationTable, setShowTranslationTable] = useState(false);
  const [showCheckinTable, setShowCheckinTable] = useState(false);
  const [reportingLanguage, setReportingLanguage] = useState(false);
  const [showTotalToday, setShowTotalToday] = useState(false);
  const [showScroll1, setShowScroll1] = useState(false);
  const [showScroll2, setShowScroll2] = useState(false);
  const [showScroll3, setShowScroll3] = useState(false);
  const [showScroll4, setShowScroll4] = useState(false);
  const [showScroll5, setShowScroll5] = useState(false);
  const [showScroll6, setShowScroll6] = useState(false);
  const [showScroll7, setShowScroll7] = useState(false);
  const [showScroll8, setShowScroll8] = useState(false);
  const [showScroll9, setShowScroll9] = useState(false);
  const [showScroll10, setShowScroll10] = useState(false);
  const [showPerfect, setShowPerfect] = useState(false);

  const history = useHistory();

  const handleFullListDetailsClick = () => {
    history.push('/admin/eventregadmin');
  };
  const {
    updateTime,
    totalEntries,
    totalToday,
    volunteers,
    englishXlation,
    cantoneseXlation,
    do3R5P,
    shuttleBus,
    checkIns,
    checkInSession,
    checkInsAnySession,
    checkin3R5P,
    scroll1,
    scroll2,
    scroll3,
    scroll4,
    scroll5,
    scroll6,
    scroll7,
    scroll8,
    scroll9,
    scroll10,
    perfectAttendeesCount
  } = useContext(ChartsContext);

  const handleCSVDownload = (data, filename) => {
    // Define the column order
    const columnOrder = [
      'id',
      'firstname',
      'lastname',
      'chinesename',
      'email',
      'phone',
      'checkedIn',
      'lastNotificationSent',
      'checkedInTime',
      'registrationTime',
      's6_9_09_30',
      's6_9_13_30',
      's13_9_09_30',
      's20_9_09_30',
      's27_9_09_30',
      's27_9_13_30',
      's4_10_09_30',
      's11_10_09_30',
      's18_10_09_30',
      's18_10_13_30',
      'checkin_6_9_09_30',
      'checkin_6_9_13_30',
      'checkin_13_9_09_30',
      'checkin_20_9_09_30',
      'checkin_27_9_09_30',
      'checkin_27_9_13_30',
      'checkin_4_10_09_30',
      'checkin_11_10_09_30',
      'checkin_18_10_09_30',
      'checkin_18_10_13_30'
    ];
  }


  // Function to handle closing (to be implemented)
  const handleTableClose = (table) => {
    if (table === 'volunteer') {
      setShowVolunteerTable(false);
    } else if (table === 'shuttleBus') {
      setShowShuttleBusTable(false);
    } else if (table === '3R5P') {
      setShowDo3R5PTable(false);
    } else if (table === 'checkin') {
      setShowCheckinTable(false);
    }
    else if (table === 'translation') {
      setShowTranslationTable(false);
    }
    else if (table === 'totalToday') {
      setShowTotalToday(false);
    } else if (table === 'scroll1') {
      setShowScroll1(false);
    } else if (table === 'scroll2') {
      setShowScroll2(false);
    } else if (table === 'scroll3') {
      setShowScroll3(false);
    } else if (table === 'scroll4') {
      setShowScroll4(false);
    } else if (table === 'scroll5') {
      setShowScroll5(false);
    } else if (table === 'scroll6') {
      setShowScroll6(false);
    } else if (table === 'scroll7') {
      setShowScroll7(false);
    } else if (table === 'scroll8') {
      setShowScroll8(false);
    } else if (table === 'scroll9') {
      setShowScroll9(false);
    } else if (table === 'scroll10') {
      setShowScroll10(false);
    } else if (table === 'perfectAttendees') {
      setShowPerfect(false);
    }
  };

  const handleDetailsButtonClick = (table) => {
    setShowVolunteerTable(table === 'volunteer');
    setShowShuttleBusTable(table === 'shuttleBus');
    setShowDo3R5PTable(table === '3R5P');
    setShowCheckinTable(table === 'checkin');
    setShowTranslationTable(table === 'translation');
    setShowTotalToday(table === 'totalToday');
    setShowScroll1(table === 'scroll1');
    setShowScroll2(table === 'scroll2');
    setShowScroll3(table === 'scroll3');
    setShowScroll4(table === 'scroll4');
    setShowScroll5(table === 'scroll5');
    setShowScroll6(table === 'scroll6');
    setShowScroll7(table === 'scroll7');
    setShowScroll8(table === 'scroll8');
    setShowScroll9(table === 'scroll9');
    setShowScroll10(table === 'scroll10');
    setShowPerfect(table === 'perfectAttendees');
  };




  return (
    <>

      <Row>
        {/* Total Registrations Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <FontAwesomeIcon icon={faUsers} className="text-info" />
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">總</span>名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={totalEntries} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={handleFullListDetailsClick}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>


        {/* Today‘s registration Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <FontAwesomeIcon icon={faCalendarWeek} className="text-success" />
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺<span className="text-warning">今日</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={totalToday} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('totalToday')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Check-in Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      <FontAwesomeIcon icon={faBuildingCircleCheck} className="text-body" />
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺已<span className="text-warning">Check-in</span>人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={checkIns} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                      {/* The count is per scroll, so say which one it belongs to. */}
                      <p className="card-category small mb-0">
                        {checkInSession
                          ? checkInSession
                          : '目前不在報到時段'}
                        <span className="ml-1">
                          （累計曾報到 {checkInsAnySession} 人）
                        </span>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('checkin')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      <CSSTransition in={showCheckinTable} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('checkin')} />
          </Col>
        </Row>
      </CSSTransition>

      <CSSTransition in={showTotalToday} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('totalToday')} />
          </Col>
        </Row>
      </CSSTransition>

      <Row>
        {/* Session 1 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-info">
                      卷一
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷一</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll1} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button " variant="twitter" onClick={() => handleDetailsButtonClick('scroll1')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>


        {/* Session 2 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-success">
                      卷二
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷二</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll2} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('scroll2')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Session 3 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-body">
                      卷三
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷三</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll3} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('scroll3')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      <CSSTransition in={showScroll1} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll1')} />
          </Col>
        </Row>
      </CSSTransition>

      <CSSTransition in={showScroll2} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll2')} />
          </Col>
        </Row>
      </CSSTransition>
      <CSSTransition in={showScroll3} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll3')} />
          </Col>
        </Row>
      </CSSTransition>



      <Row>
        {/* Session 1 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-info">
                      卷四
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷四</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll4} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button " variant="twitter" onClick={() => handleDetailsButtonClick('scroll1')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>


        {/* Session 2 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-success">
                      卷五
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷五</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll5} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('scroll2')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Session 3 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-body">
                      卷六
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷六</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll6} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('scroll3')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      <CSSTransition in={showScroll1} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll4')} />
          </Col>
        </Row>
      </CSSTransition>

      <CSSTransition in={showScroll2} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll5')} />
          </Col>
        </Row>
      </CSSTransition>
      <CSSTransition in={showScroll3} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll6')} />
          </Col>
        </Row>
      </CSSTransition>


      <Row>
        {/* Session 7 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-info">
                      卷七
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷七</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll7} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button " variant="twitter" onClick={() => handleDetailsButtonClick('scroll1')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>


        {/* Session 8 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-success">
                      卷八
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷八</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll8} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('scroll2')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Session 9 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-body">
                      卷九
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷九</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll9} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('scroll3')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      <CSSTransition in={showScroll1} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll7')} />
          </Col>
        </Row>
      </CSSTransition>

      <CSSTransition in={showScroll2} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll8')} />
          </Col>
        </Row>
      </CSSTransition>
      <CSSTransition in={showScroll3} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll9')} />
          </Col>
        </Row>
      </CSSTransition>




      <Row>
        {/* Session 10 Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-info">
                      卷十
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">卷十</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={scroll10} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            {/* <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('scroll3')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger> */}
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning text-info">
                      全勤
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">梁皇寶懺報<span className="text-warning">全勤</span>人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={perfectAttendeesCount} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('perfectAttendees')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      <CSSTransition in={showScroll1} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('scroll10')} />
          </Col>
        </Row>
      </CSSTransition>
      <CSSTransition in={showPerfect} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <PerfectAttendeesTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('perfectAttendees')} />
          </Col>
        </Row>
      </CSSTransition>
    </>
  );
}

export default DataSnapshots;
